<template lang="pug">
#tabela-relacionamentos-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    div(v-if='dados.relacionamentos')
        el-table.fixed-header-table(
            :data='paginatedItems',
            :default-sort='{ prop: "nome", order: "ascending" }',
            style='width: 100%; height: 100%; max-height: 450px; overflow: auto',
            stripe,
            v-loading='isLoading'
        )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.relacionamentos.nome")',
                prop='nome',
                align='left',
                sortable,
                min-width='200px'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.relacionamentos.cpf")',
                prop='cpf',
                :formatter='formatCpfCnpjTableColumn',
                align='left',
                min-width='100px'
            )
            el-table-column(
                :label='$t("mensagens.preAnaliseCredito.relacionamentos.relacaoFamiliar")',
                prop='descricao',
                align='left',
                min-width='100px'
            )
        .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
            .tabela-rodape-somatorio(v-if='dados.relacionamentos')
                p {{ dados.relacionamentos.length }}{{ dados.relacionamentos.length === 1 ? $t('mensagens.preAnaliseCredito.relacionamentos.relacaoFamiliarMinusculo') : $t('mensagens.preAnaliseCredito.relacionamentos.relacoesFamiliaresMinusculo') }}
            el-pagination(
                v-if='dados.relacionamentos.length > 0',
                :page-size='itemsPorPagina',
                :pager-count='5',
                layout='prev, pager, next',
                :total='dados.relacionamentos.length',
                @prev-click='avancarPagina',
                @next-click='voltarPagina',
                @current-change='atualizarPagina'
            )
    el-alert(
        v-if='!dados.relacionamentos',
        :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${tituloTabela}`',
        type='warning',
        :closable='false'
    )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';

export default {
    name: 'TabelaRelacionamentosPf',

    components: {
        BaseTableHeader
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-account-group-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0'],
            items: [],
            isLoading: false,
            paginaAtual: 1,
            itemsPorPagina: 7
        };
    },

    created() {
        this.items = this.dados.relacionamentos;
    },

    computed: {
        totalPages() {
            return Math.ceil(this.items.length / this.itemsPorPagina);
        },
        paginatedItems() {
            const startIndex = (this.paginaAtual - 1) * this.itemsPorPagina;
            const endIndex = startIndex + this.itemsPorPagina;
            return this.items.slice(startIndex, endIndex);
        }
    },

    methods: {
        formatCpfCnpjTableColumn(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        voltarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual > 1) {
                    this.paginaAtual--;
                }
            }, 550);
        },
        avancarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual < this.totalPages) {
                    this.paginaAtual++;
                }
            }, 550);
        },
        atualizarPagina(pagina) {
            this.handleLoadingTable();
            setTimeout(() => {
                this.paginaAtual = pagina;
            }, 550);
        },
        handleLoadingTable() {
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 500);
        }
    }
};
</script>

<style lang="scss">
#tabela-relacionamentos-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;
    height: calc(100vh - 312px);

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    .fixed-header-table .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-table {
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        height: 100%;

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding: 17px 0 15px 21px;
    }

    .el-pagination {
        padding: 16px 75px 16px 0;
        color: #3b3b3b;
    }

    .el-pager li.active {
        color: #00413c;
        font-weight: 600;
        font-size: 15px;
        background: #00413c24;
    }
}
</style>
